import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectSymbolMarketMakerWatchlist: "selectSymbolMarketMakerWatchlist [Action]",
  selectSymbolMarketMakerWatchlistLoading:
    "selectSymbolMarketMakerWatchlistLoading [Action]",
  selectSymbolMarketMakerWatchlistAsync:
    "selectSymbolMarketMakerWatchlistAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_symbol_market_maker_watchlist_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectSymbolMarketMakerWatchlist:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectSymbolMarketMakerWatchlistLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectSymbolMarketMakerWatchlistLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "market_maker",
    method_type: "select_symbol_market_maker_watchlist",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectSymbolMarketMakerWatchlist,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectSymbolMarketMakerWatchlistLoading,
      payload: false,
    });
  }
}

export function* selectSymbolMarketMakerWatchlist() {
  yield takeLatest(
    actionTypes.selectSymbolMarketMakerWatchlistAsync,
    handleWorker
  );
}
